/**
 * Akce pro hromadné tabulkové zobrazení a úpravy AS.
 */

import { WebApi } from 'actions/index';
import * as types from 'actions/constants/ActionTypes';
import { objectById } from 'stores/app/utils';
import { COL_REFERENCE_MARK } from 'components/arr/FundDataGridConst';
import { Api } from 'api';
import {} from 'components/shared';
import { FormattedMessage, defineMessages } from 'react-intl';

// Id jsou převzatá z legacy katalogu beze změny.
const messages = defineMessages({
    loadFailed: { id: "dataGrid.loadFailed", defaultMessage: "Načtení dat tabulky se nezdařilo." },
    nodeNotFoundFiltered: { id: "dataGrid.restore.nodeNotFound.filtered", defaultMessage: "Dříve vybraná jednotka popisu neodpovídá aktuálnímu filtru, zobrazuje se uložená stránka." },
    nodeNotFound: { id: "dataGrid.restore.nodeNotFound", defaultMessage: "Dříve vybranou jednotku popisu se nepodařilo obnovit, zobrazuje se uložená stránka." },
});
import { addToastrDanger, addToastrWarning } from 'components/shared/toastr/ToastrActions';

// Null hodnota, která se používaná v klientovi pro reprezentaci null hodnoty
export const FILTER_NULL_VALUE = '____$<NULL>$___';

export function isFundDataGridAction(action) {
    switch (action.type) {
        case types.FUND_FUND_DATA_GRID_INIT:
        case types.FUND_FUND_DATA_GRID_FILTER:
        case types.FUND_FUND_DATA_GRID_FILTER_REQUEST:
        case types.FUND_FUND_DATA_GRID_FILTER_RECEIVE:
        case types.FUND_FUND_DATA_GRID_FILTER_CHANGE:
        case types.FUND_FUND_DATA_GRID_DATA_REQUEST:
        case types.FUND_FUND_DATA_GRID_DATA_RECEIVE:
        case types.FUND_FUND_DATA_GRID_DATA_ERROR:
        case types.FUND_FUND_DATA_GRID_COLUMN_SIZE:
        case types.FUND_FUND_DATA_GRID_COLUMNS_SETTINGS:
        case types.FUND_FUND_DATA_GRID_FILTER_CLEAR_ALL:
        case types.FUND_FUND_DATA_GRID_FULLTEXT_RESULT:
        case types.FUND_FUND_DATA_GRID_FULLTEXT_CLEAR:
        case types.FUND_FUND_DATA_GRID_FULLTEXT_EXTENDED:
        case types.FUND_FUND_DATA_GRID_FULLTEXT_NEXT_ITEM:
        case types.FUND_FUND_DATA_GRID_FULLTEXT_PREV_ITEM:
            return true;
        default:
            return false;
    }
}

export function fundBulkModifications(
    versionId,
    descItemTypeId,
    specsIds,
    operationType,
    findText,
    replaceText,
    description,
    replaceSpecId,
    nodes,
    selectionType,
    replaceValueId,
    valueIds,
) {
    console.log(
        '#####fundBulkModifications',
        versionId,
        descItemTypeId,
        specsIds,
        operationType,
        findText,
        replaceText,
        replaceSpecId,
        nodes,
        selectionType,
    );

    return (dispatch, getState) => {
        switch (operationType) {
            case 'findAndReplace':
                return WebApi.replaceDataValues(
                    versionId,
                    descItemTypeId,
                    specsIds,
                    findText,
                    replaceText,
                    nodes,
                    selectionType,
                );
            case 'replace':
                return WebApi.placeDataValues(
                    versionId,
                    descItemTypeId,
                    specsIds,
                    replaceText,
                    description,
                    replaceSpecId,
                    nodes,
                    selectionType,
                );
            case 'append':
                return WebApi.placeDataValues(
                    versionId,
                    descItemTypeId,
                    specsIds,
                    replaceText,
                    description,
                    replaceSpecId,
                    nodes,
                    selectionType,
                    true
                );
            case 'delete':
                return WebApi.deleteDataValues(versionId, descItemTypeId, specsIds, nodes, selectionType, valueIds);
            case 'setSpecification':
                return WebApi.setSpecification(
                    versionId,
                    descItemTypeId,
                    specsIds,
                    replaceSpecId,
                    nodes,
                    selectionType,
                );
            case 'setValue':
                return WebApi.setDataValues(
                    versionId,
                    descItemTypeId,
                    specsIds,
                    replaceValueId,
                    nodes,
                    selectionType,
                    valueIds
                );
            default:
                console.warn('#####fundBulkModifications - operation not implemented', operationType);
                return null;
        }
    };
}

export function fundDataInitIfNeeded(versionId, initData) {
    return (dispatch, getState) => {
        const fundDataGrid = getFundDataGrid(getState, versionId);
        if (fundDataGrid && !fundDataGrid.initialised) {
            dispatch({
                type: types.FUND_FUND_DATA_GRID_INIT,
                versionId,
                initData,
            });
        }
    };
}

export function fundDataFulltextSearch(versionId, filterText, luceneQuery, searchParams, data) {
    return (dispatch, getState) => {
        return WebApi.getFilteredFulltextNodes(versionId, filterText, luceneQuery, searchParams).then(json => {
            dispatch(fundDataFulltextSearchResult(versionId, filterText, luceneQuery, json, data));
        });
    };
}

function fundDataFulltextSearchResult(versionId, filterText, luceneQuery, searchedItems, data) {
    return {
        type: types.FUND_FUND_DATA_GRID_FULLTEXT_RESULT,
        versionId,
        filterText,
        luceneQuery,
        searchedItems,
        data,
    };
}

export function fundDataFulltextExtended(versionId) {
    return {
        type: types.FUND_FUND_DATA_GRID_FULLTEXT_EXTENDED,
        versionId,
    };
}

export function fundDataFulltextClear(versionId) {
    return {
        type: types.FUND_FUND_DATA_GRID_FULLTEXT_CLEAR,
        versionId,
    };
}

export function fundDataFulltextPrevItem(versionId) {
    return {
        type: types.FUND_FUND_DATA_GRID_FULLTEXT_PREV_ITEM,
        versionId,
    };
}

export function fundDataFulltextNextItem(versionId) {
    return {
        type: types.FUND_FUND_DATA_GRID_FULLTEXT_NEXT_ITEM,
        versionId,
    };
}

function getFundDataGrid(getState, versionId) {
    const state = getState();
    const fund = objectById(state.arrRegion.funds, versionId, 'versionId');
    if (!fund) {
        return null;
    }

    const fundDataGrid = fund.fundDataGrid;
    return fundDataGrid;
}

export function fundDataGridFetchFilterIfNeeded(versionId) {
    return (dispatch, getState) => {
        const fundDataGrid = getFundDataGrid(getState, versionId);
        if (fundDataGrid && !fundDataGrid.fetchedFilter && !fundDataGrid.isFetchingFilter) {
            dispatch(fundDataGridFilter(versionId, fundDataGrid.filter));
        }
    };
}

function _fundDataGridKey(state, pageIndex, pageSize) {
    var str = '';
    str += '-pg' + pageSize;
    str += '-pi' + pageIndex;
    str += '-vc';
    Object.keys(state.visibleColumns)
        .sort()
        .forEach(k => {
            str += '-' + k;
        });
    str += '-fi';
    Object.keys(state.filter)
        .sort()
        .forEach(k => {
            str += '-' + k;
            str += JSON.stringify(state.filter[k]);
        });
    return str;
}

export function fundDataGridFilterClearAll(versionId) {
    return {
        type: types.FUND_FUND_DATA_GRID_FILTER_CLEAR_ALL,
        versionId,
    };
}

export function fundDataGridImport(versionId, fundId, file, separator) {
    return async (dispatch) => {
        const { data: jobId } = await Api.funds.fundImportFundData(fundId, "CSV", file, separator);
        return dispatch(fundDataGridRefreshRows(versionId));
    }
}

/**
 * Aktualizace řádek v tabulce - zachová aktuální stránku, ale znovu přefiltruje data.
 * @param versionId verze AS
 */
export function fundDataGridRefreshRows(versionId) {
    return (dispatch, getState) => {
        const fundDataGrid = getFundDataGrid(getState, versionId);
        if (!fundDataGrid) {
            return;
        }

        dispatch(_fundDataGridFilter(versionId, fundDataGrid.filter, false));
    };
}

export function fundDataGridFilterChange(versionId, filter) {
    return (dispatch, getState) => {
        dispatch({
            type: types.FUND_FUND_DATA_GRID_FILTER_CHANGE,
            versionId,
            filter,
        });
    };
}

export function fundDataGridFetchDataIfNeeded(versionId, pageIndex, pageSize, force = false) {
    return async (dispatch, getState) => {
        const fundDataGrid = getFundDataGrid(getState, versionId);
        if (!fundDataGrid && !force) {
            return;
        }

        if ((!fundDataGrid.fetchedFilter || fundDataGrid.isFetchingFilter) && !force) {
            // již musí být načtený filtr
            return;
        }

        const dataKey = _fundDataGridKey(fundDataGrid, pageIndex, pageSize);
        if (fundDataGrid.currentDataKey !== dataKey || force) {
            dispatch(_dataRequest(versionId, dataKey));

            const descItemTypeIds = Object.keys(fundDataGrid.visibleColumns);

            let response;
            try {
                response = await WebApi.getFilteredNodes2(versionId, pageIndex, pageSize, descItemTypeIds);
            } catch (e) {
                // Reset the fetch state so the same page can be requested again.
                dispatch(_dataError(versionId));
                dispatch(addToastrDanger(<FormattedMessage {...messages.loadFailed} />));
                return;
            }

            const newState = getState();
            const newFund = objectById(newState.arrRegion.funds, versionId, 'versionId');
            if (newFund === null) {
                return;
            }

            const newFundDataGrid = newFund.fundDataGrid;
            const newDataKey = _fundDataGridKey(newFundDataGrid, pageIndex, pageSize);
            if (newDataKey !== dataKey) {
                return;
            }

            const items = response.rows.map(node => {
                const { valuesMap, ...nodeRest } = node;
                return {
                    id: nodeRest.node.id,
                    ...nodeRest,
                    ...node.valuesMap,
                    referenceMark: node.referenceMark,
                };
            });

            dispatch(_dataReceive(versionId, items));
        }
    };
}

/**
 * Dopočítá stránku, na které se ve filtrovaném seznamu nachází daný uzel.
 * Vrací číslo stránky, nebo null pokud uzel v seznamu není (odfiltrován / mimo fond).
 */
export function fundDataGridResolveNodePage(versionId, nodeId, pageSize) {
    return async (dispatch, getState) => {
        const fundDataGrid = getFundDataGrid(getState, versionId);
        const descItemTypeIds = fundDataGrid ? Object.keys(fundDataGrid.visibleColumns) : [];
        try {
            const response = await WebApi.getFilteredNodesByNodeId(versionId, nodeId, pageSize, descItemTypeIds);
            return response.page;
        } catch (e) {
            // With an active filter a missing node is expected, so warn only.
            const hasActiveFilter = fundDataGrid && Object.keys(fundDataGrid.filter).length > 0;
            if (hasActiveFilter) {
                dispatch(addToastrWarning(<FormattedMessage {...messages.nodeNotFoundFiltered} />));
            } else {
                dispatch(addToastrDanger(<FormattedMessage {...messages.nodeNotFound} />));
            }
            return null;
        }
    };
}

/**
 * Obecné nastavení sloupečků.
 */
export function fundDataGridSetColumnsSettings(versionId, visibleColumns, columnsOrder) {
    return {
        type: types.FUND_FUND_DATA_GRID_COLUMNS_SETTINGS,
        versionId,
        visibleColumns,
        columnsOrder,
    };
}

/**
 * Nastavení šířky sloupečku.
 */
export function fundDataGridSetColumnSize(versionId, columnId, width) {
    return {
        type: types.FUND_FUND_DATA_GRID_COLUMN_SIZE,
        versionId,
        columnId,
        width,
    };
}

/**
 * Filtrování dat podle předaného filtru.
 */
export function fundDataGridFilter(versionId, filter) {
    return _fundDataGridFilter(versionId, filter, true);
}

export function createFilterStructure(filter) {
    const callFilter = { columnFilters: { filters: {} } };

    // Ladění objektu filtru pro server
    Object.keys(filter).forEach(key => {
        if (key === COL_REFERENCE_MARK) {
            callFilter.nodeId = filter[COL_REFERENCE_MARK].nodeId;
        } else {
            callFilter.columnFilters.filters[key] = { ...filter[key] };
            const filterData = callFilter.columnFilters.filters[key];

            // Typy selected a unselected na velká písmena
            if (typeof filterData.specsType !== 'undefined' && filterData.specsType !== null) {
                filterData.specsType = filterData.specsType.toUpperCase();
            }
            if (typeof filterData.valuesType !== 'undefined' && filterData.valuesType !== null) {
                filterData.valuesType = filterData.valuesType.toUpperCase();
            }

            // Hodnoty null na reálné null
            if (filterData.values) {
                filterData.values = filterData.values.map(v => {
                    return v === FILTER_NULL_VALUE ? null : v;
                });
            }
            if (filterData.specs) {
                filterData.specs = filterData.specs.map(v => {
                    return v === FILTER_NULL_VALUE ? null : Number(v);
                });
            }
        }
    });
    return callFilter;
}

function _fundDataGridFilter(versionId, filter, resetViewState = true) {
    return (dispatch, getState) => {
        dispatch(_filterRequest(versionId));
        const callFilter = createFilterStructure(filter);

        WebApi.filterNodes(versionId, callFilter).then(json => {
            dispatch(_filterReceive(versionId, json, resetViewState));
        });
    };
}

/**
 * Byl volán request na filtrování dat.
 */
function _filterRequest(versionId) {
    return {
        type: types.FUND_FUND_DATA_GRID_FILTER_REQUEST,
        versionId,
    };
}

/**
 * Byla vyfiltrována data.
 */
function _filterReceive(versionId, itemsCount, resetViewState) {
    return {
        type: types.FUND_FUND_DATA_GRID_FILTER_RECEIVE,
        versionId,
        itemsCount,
        resetViewState,
    };
}

/**
 * Byl volán request na data.
 */
function _dataRequest(versionId, dataKey) {
    return {
        type: types.FUND_FUND_DATA_GRID_DATA_REQUEST,
        versionId,
        dataKey,
    };
}

/**
 * Byla vrácena data.
 */
function _dataReceive(versionId, items) {
    return {
        type: types.FUND_FUND_DATA_GRID_DATA_RECEIVE,
        versionId,
        items,
    };
}

/**
 * Načtení dat selhalo - resetuje stav načítání, aby šlo požadavek zopakovat.
 */
function _dataError(versionId) {
    return {
        type: types.FUND_FUND_DATA_GRID_DATA_ERROR,
        versionId,
    };
}
